

import { AddLeadModal } from './triageDeskShared';
import { useTriageController } from './useTriageController';
export function TriageIntakeDialog({ ctx }: { ctx: ReturnType<typeof useTriageController> }) {
const { setTab, setSearch, setToasts, productOptions, addLeadOpen, setAddLeadOpen, setLeadsRefresh } = ctx;
return (<>{addLeadOpen && (
        <AddLeadModal
          productOptions={productOptions}
          onClose={() => setAddLeadOpen(false)}
          onCreated={(name) => {
            setAddLeadOpen(false);
            // The created lead is UNVERIFIED + UNASSIGNED → Unassigned tab.
            setTab('unassigned');
            setSearch('');
            setLeadsRefresh((n) => n + 1);
            const toastId = Math.random().toString(36).slice(2);
            setToasts((t) => [...t, { id: toastId, text: `Lead "${name}" added to the Unassigned queue` }]);
            setTimeout(() => setToasts((tt) => tt.filter((x) => x.id !== toastId)), 5000);
          }}
          onOpenExisting={(m, phone) => {
            // Deep-link: close the modal, jump to the tab holding the match,
            // and search by the phone's last-10 so the row surfaces.
            setAddLeadOpen(false);
            const MANUALS = ['MANUAL', 'manual', 'walkin', 'mobile-capture', 'self_made'];
            setTab(
              m.sourceName && MANUALS.includes(m.sourceName)
                ? 'self_made'
                : m.assignedToName
                ? 'assigned'
                : 'unassigned',
            );
            const digits = phone.replace(/\D/g, '');
            setSearch(digits.length >= 10 ? digits.slice(-10) : phone);
          }}
        />
      )}
    </>);
}
